import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import {
  QRCode as QRCodeComponent,
  QRCodeComponentProps,
} from "../../components/QRCode";

import { getReferral } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getCampaignId,
  getIsLoadingQR,
  getMerchantId,
  getQR,
  getQRError,
  getWidgetConfigId,
} from "../../reducers/methods";
import { QR_CODE_CHANNEL } from "../../constants";

interface QRCodeContainerProps extends QRCodeComponentProps {
  getReferral: typeof getReferral;
  error: ReturnType<typeof getQRError>;
  isLoading: ReturnType<typeof getIsLoadingQR>;
  qr: ReturnType<typeof getQR>;
  campaignId: string;
  merchantId: string;
  widgetConfigId: string;
}

class QRCode extends React.Component<QRCodeContainerProps> {
  componentDidMount() {
    const customer = get(this.props.data, "customer", {});

    if (customer.email && !this.props.isLoading && isEmpty(this.props.qr)) {
      this.props.getReferral({
        channel: QR_CODE_CHANNEL,
        email: customer.email,
        campaignId: this.props.campaignId,
        merchantId: this.props.merchantId,
        widgetConfigId: this.props.widgetConfigId,
        // Guard against null name values
        name: customer.name || undefined,
      });
    }
  }

  render() {
    return <QRCodeComponent {...this.props} qrReferral={this.props.qr} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsLoadingQR(state),
  qr: getQR(state),
  campaignId: getCampaignId(state),
  merchantId: getMerchantId(state),
  widgetConfigId: getWidgetConfigId(state),
  error: getQRError(state),
});

export default connect(mapStateToProp, { getReferral })(QRCode);
